import React, { useState, useEffect  } from 'react'
import {
  Row,
  Col,
  Progress,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Slider from '@material-ui/core/Slider';
import { withStyles } from '@material-ui/core/styles';

const PrettoSlider = withStyles({
  root: {
    color: '#52af77',
    // height: 8,
    height: 16,
  },
  thumb: {
    display: 'none',
    height: 24,
    width: 24,
    // backgroundColor: '#fff',
    backgroundColor: 'red',
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    // height: 8,
    height: 16,
    borderRadius: 4,
  },
  rail: {
    // height: 8,
    height: 16,
    borderRadius: 4,
  },
})(Slider);

// AudioProgressiveBar
const AudioProgressiveBar = (props) => {

  let [progressValue, setProgressValue] = useState(0);
  let [processsInitialized, setProcesssInitialized] = useState(false);
  let [playing, setPlaying] = useState(false)

  // componentDidMount
  useEffect(() => {

    setPlaying(props.playing)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.playing]);

  // componentDidMount
  useEffect(() => {

    setPlaying(props.isLeftAudioPlaying)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isLeftAudioPlaying]);


  // componentDidMount
  useEffect(() => {

    if (props.currentTime === 0 && props.clipStart === 0) {
      return;
    }
    // set progress value for clip
    let _progressClipValue = 100 * props.currentTime / props.duration
    setProgressValue(_progressClipValue)

    // set initialized true
    setProcesssInitialized(true)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.currentTime, props.clipStart]);

  // slider is changed
  let _handleChangeSlider = async (event, new_value) => {
    props.updateCurrentPercent(new_value)
  }

  return (
    <div className="shadow2dp" style={{
      backgroundColor: 'rgb(255 255 255 / 75%)',
      padding: 14,
      paddingBottom: 6,
      position: 'fixed',
      top: 100,
      right: 120,
      // left: 120,
      width: 300,
      zIndex: 10,
    }}>

      <Row>

        <Col md="12" xs="12">

          <Row>
            <Col md="12" xs="12" style={{
              // textAlign: 'left',
              // fontSize: 34,
              fontSize: 17,
            }}>

              <FontAwesomeIcon
                icon={props.playing === true ? 'pause' : 'play-circle'}
                onClick={props.togglePlayAudio}
                style={{
                  fontSize: 24,
                  cursor: 'pointer',
                  color: 'navy',
                  display: 'block',
                  float: 'left',
                  marginRight: 10,
              }}/>

              <span style={{
                // marginLeft: 15,
              }}>
                {props.currentTime.toFixed(2)}
              </span>

              {props.duration && isFinite(props.duration) === true && (
                <span style={{
                  float: 'right',
                }}>
                  {props.duration.toFixed(2)}
                </span>
              )}

            </Col>
          </Row>

          <Row style={{
            marginTop: 8,
          }}>
            <Col md="12" xs="12">
              {processsInitialized === true && (
                <PrettoSlider
                  value={progressValue}
                  onChange={_handleChangeSlider}
                  aria-labelledby="continuous-slider" />
              )}
            </Col>
          </Row>
        </Col>
      </Row>

    </div>
  )
}

// <Progress value={progressValue} />

export default AudioProgressiveBar
